import rootStore from '@vue-storefront/core/store'

// Single source of truth for "is this payment code an online method."
// Reads the `offline` flag off whatever's actually registered in the
// payment module (core/modules/checkout/store/payment), which each payment
// method's own afterRegistration hook populates (see e.g.
// src/modules/ipay-payment/hooks/afterRegistration.ts,
// src/modules/custom-payments/hooks/afterRegistration.ts). Adding, removing,
// or changing a payment method only requires touching its own registration
// hook - nothing here needs to change, and no other component needs its
// own copy of a payment-code list.
export function isOnlinePaymentMethod (code) {
  const methods = rootStore.getters['payment/allPaymentMethods'] || []
  const method = methods.find(m => m.code === code)

  return !!method && !method.offline
}
